import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
  const handleManageCookies = () => {
    // Trigger cookie banner reopen
    window.dispatchEvent(new CustomEvent('openCookieBanner'));
  };

  return (
    <div className="min-h-screen bg-slate-50 py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">Cookie Policy</h1>
          <p className="text-slate-600 mb-8"><strong>Ultimo aggiornamento:</strong> 25/09/2026</p>

          <p className="text-slate-700 mb-8">Questo sito, di proprietà di Edilservice 2.0 S.R.L. (P.IVA 08848480722, Strada Comunale Mezzane), utilizza cookie e tecnologie simili. Questa pagina spiega cosa sono, quali usiamo e come puoi gestirli.</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Cosa sono i cookie</h2>
            <p className="text-slate-700">I cookie sono piccoli file di testo che i siti visitati inviano al tuo dispositivo, dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Cookie tecnici (sempre attivi)</h2>
            <p className="text-slate-700">Sono necessari al funzionamento del sito (es. ricordare gli articoli inseriti nel carrello, le preferenze di visualizzazione). Non richiedono consenso perché indispensabili per erogare il servizio richiesto.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Cookie di analisi (richiedono il tuo consenso)</h2>
            <p className="text-slate-700 mb-4">Utilizziamo PostHog, uno strumento che raccoglie informazioni su come i visitatori usano il sito (pagine visitate, percorso di navigazione, ed eventualmente registrazione della sessione di navigazione). Questi dati ci aiutano a capire come viene usato il sito e a migliorarlo.</p>
            <p className="text-slate-700 mb-4">Questi cookie/script si attivano solo se acconsenti tramite il banner mostrato alla prima visita. Se non acconsenti, PostHog non viene caricato.</p>
            
            <div className="overflow-x-auto mb-4">
              <table className="w-full border-collapse border border-slate-300">
                <thead className="bg-slate-100">
                  <tr>
                    <th className="border border-slate-300 px-4 py-2 text-left text-slate-800">Servizio</th>
                    <th className="border border-slate-300 px-4 py-2 text-left text-slate-800">Fornitore</th>
                    <th className="border border-slate-300 px-4 py-2 text-left text-slate-800">Finalità</th>
                    <th className="border border-slate-300 px-4 py-2 text-left text-slate-800">Sede del fornitore</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-slate-300 px-4 py-2 text-slate-700">PostHog</td>
                    <td className="border border-slate-300 px-4 py-2 text-slate-700">PostHog Inc.</td>
                    <td className="border border-slate-300 px-4 py-2 text-slate-700">Analisi statistica, eventuale registrazione sessione</td>
                    <td className="border border-slate-300 px-4 py-2 text-slate-700">Stati Uniti</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="text-slate-700">Puoi consultare l'informativa privacy di PostHog su <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer" className="text-orange-600 hover:underline">posthog.com/privacy</a>.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Come gestire le tue preferenze</h2>
            <p className="text-slate-700 mb-4">Puoi accettare o rifiutare i cookie di analisi tramite il banner che compare alla prima visita del sito. Puoi modificare la tua scelta in qualsiasi momento cliccando sul pulsante qui sotto:</p>
            
            <button
              onClick={handleManageCookies}
              className="bg-orange-600 text-white px-6 py-3 rounded-lg hover:bg-orange-700 transition-colors font-medium"
            >
              Gestisci preferenze cookie
            </button>

            <p className="text-slate-700 mt-6">Puoi inoltre bloccare i cookie direttamente dalle impostazioni del tuo browser; tieni presente che disabilitare i cookie tecnici potrebbe impedire il corretto funzionamento di alcune parti del sito (es. il carrello).</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Contatti</h2>
            <p className="text-slate-700">Per domande su questa Cookie Policy, scrivici a <a href="mailto:edilserviceduepuntozerosrl@gmail.com" className="text-orange-600 hover:underline">edilserviceduepuntozerosrl@gmail.com</a>.</p>
          </section>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <Link to="/" className="text-orange-600 hover:underline font-medium">← Torna alla Home</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
